<script setup lang="ts">
useHeadCommon()
</script>
<template>
  <div class="layout layout-cbz">
    <AccessibilityQuickLinks />
    <slot />
  </div>
</template>
